import { Delete, Edit } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputAdornment,
  TextField,
} from "@mui/material";
import { currency } from "../../MUI_components/currencyFormatterTag";
import { NumFormat } from "../../MUI_components/currencyFormat";
import FromControl from "../../MUI_components/FormControl/fomikFormControl";
import FormControlLabel from "@mui/material/FormControlLabel";

import { Field, Form, Formik, FieldArray } from "formik";

const PREFIX = "AddingStockTable";
const classes = {
  table: `${PREFIX}-table`,
};

export default function SpanningTable({ data, remove, setStock, code, grnValue, setGrnValue, stock }) {
  const handleChangeDiscountAmount = (event) => {
    setGrnValue({
      ...grnValue,
      discountAmount: event.target.value
    });
  };

  const handleChangeDiscountPercentage = (event) => {
    setGrnValue({
      ...grnValue,
      discountPercentage: event.target.value
    });
  };

  const handleFieldChange = (e, index, field) => {
    const newValue = e.target.value;
    
    // Check if the new value is not negative
    if (newValue >= 0) {
      const newData = [...data];
      newData[index][field] = newValue;
      setStock(newData);
    }
  };
  

  function total(data) {
    return data
      .map(({ quantity, costPrice, discountAmount, discountPercentage }) =>
        ((quantity * costPrice) - (discountAmount * quantity)) - ((quantity * costPrice) * (discountPercentage / 100)))
      .reduce((sum, i) => sum + i, 0);
  }

  //This is GRN Level discount
  function callDiscountAmount(data) {

    let disAmt = grnValue.discountAmount;
    let disPer = grnValue.discountPercentage;
    let subTotal = total(data);
    let amt = (disPer / 100 * subTotal) + parseFloat(disAmt ? disAmt : 0);// discountAmount;

    return amt;

  }
  const CustomInput = (props) => {
    return (
      <input
        type="number"
        style={{
          fontSize: 12,
          width: props.width ? props.width : 50,
          maxWidth: 200,
        }}
        step="any"
        {...props}
        className="custom-input"
      />
    );
  };
  return (
    <TableContainer>
      <Table className={classes.table} size="small" aria-label="spanning table">
        <TableHead style={{ backgroundColor: "#cacaca50" }}>
          <TableRow>
            <TableCell width="5"></TableCell>
            <TableCell>#</TableCell>
            <TableCell>Item name</TableCell>
            <TableCell align="right">Qty.</TableCell>
            <TableCell align="right">Cost Price</TableCell>
            <TableCell align="right">Retail Price</TableCell>
            <TableCell align="right">Dis %</TableCell>
            <TableCell align="right">Dis Amt</TableCell>
            <TableCell align="right">Sum</TableCell>
          </TableRow>

        </TableHead>
        <TableBody>
          {data.map((row, index) => {
            return (
              <TableRow key={index}>
                <TableCell>
                  <div className="flex">
                    {!code && (
                      <Delete
                        color="secondary"
                        style={{ fontSize: 18, cursor: "pointer" }}
                        onClick={() => {
                          if (
                            window.confirm("Are you sure want to delete this?")
                          )
                            remove(index);
                        }}
                      />
                    )}
                    {/* <Edit
                      color="primary"
                      style={{ fontSize: 18, cursor: "pointer" }}
                      onClick={() => {
                        setStock({ ...data[index], editIndex: index });
                      }}
                    /> */}
                  </div>
                </TableCell>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.itemMaster ? row.itemMaster.name : row.name}</TableCell>
                <TableCell align="right">
                  <TextField
                    size="small"
                    type="number"
                    value={row.quantity}
                    onChange={(e) => handleFieldChange(e, index, 'quantity')}
                    style={{ width: 60 }} 
                  />
                </TableCell>
                <TableCell align="right">
                  <TextField
                    size="small"
                    type="number"
                    value={row.costPrice}
                    onChange={(e) => handleFieldChange(e, index, 'costPrice')}
                    style={{ width: 100 }} 
                  />
                </TableCell>
                <TableCell align="right">
                  <TextField
                    size="small"
                    type="number"
                    value={row.retailPrice}
                    onChange={(e) => handleFieldChange(e, index, 'retailPrice')}
                    style={{ width: 100 }} 
                  />
                </TableCell>
                <TableCell align="right">
                  <TextField
                    size="small"
                    type="number"
                    value={row.discountPercentage}
                    onChange={(e) => handleFieldChange(e, index, 'discountPercentage')}
                    style={{ width: 60 }} 
                  />
                </TableCell>
                <TableCell align="right">
                  <TextField
                    size="small"
                    type="number"
                    value={row.discountAmount}
                    onChange={(e) => handleFieldChange(e, index, 'discountAmount')}
                    style={{ width: 60 }} 
                  />
                </TableCell>

                <TableCell align="right"> {currency(row.costPrice * row.quantity - ((row.discountAmount * row.quantity) + ((row.costPrice * row.quantity) * row.discountPercentage / 100)))}</TableCell>

                {/* <TableCell align="right"> {currency((row.quantity * row.costPrice) - (row.discountAmount * row.quantity)) - currency((row.quantity * row.costPrice) * (row.discountPercentage/100))}
                </TableCell> */}
              </TableRow>
            );
          })}

          {data.length === 0 ? (
            <TableRow>
              <TableCell align="center" colSpan={7}>
                <strong>No Data </strong>
              </TableCell>
            </TableRow>
          ) : (
            <>
              <TableRow>
                <TableCell colSpan={4} rowSpan={3} />
                <TableCell colSpan={4}>
                  Sub Total
                </TableCell>
                <TableCell align="right">
                  {currency(total(data))}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell colSpan={2}>Bill Discount</TableCell>
                <TableCell align="right">Dis %
                  <TextField id="standard-basic"
                    value={grnValue.discountPercentage}
                    onChange={handleChangeDiscountPercentage}
                    variant="standard" />
                </TableCell>

                <TableCell align="right">Dis Amt
                  <TextField id="standard-basic"
                    value={grnValue.discountAmount}
                    onChange={handleChangeDiscountAmount}
                    variant="standard" />
                </TableCell>
                <TableCell align="right">
                  <strong>{currency(callDiscountAmount(data))}</strong>
                </TableCell>
              </TableRow>


              <TableRow style={{ backgroundColor: "#cacaca50", }}>
                <TableCell colSpan={4}>
                  <strong>Total</strong>
                </TableCell>
                <TableCell align="right">
                  <strong>{currency(total(data) - callDiscountAmount(data))}</strong>
                </TableCell>
              </TableRow>
            </>
          )}
        </TableBody>

      </Table>
    </TableContainer>
  );
}